module.exports = __webpack_public_path__ + "static/img/Three of Pentacles.2706427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Three of Pentacles.jpg
// module id = 1326
// module chunks = 0